import { render, staticRenderFns } from "./ExternalSystemLogin.vue?vue&type=template&id=0d120844"
import script from "./ExternalSystemLogin.vue?vue&type=script&lang=js"
export * from "./ExternalSystemLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports